import { h, Fragment } from 'preact'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

const Reference = props => {
  let reference = props.reference
  let content = reference.content.rendered
  let person = reference.custom_meta[0].person
  let company = reference.custom_meta[0].company
  let project_slug = reference.custom_meta[0].project_slug
  let project_url = `/referentie/${project_slug}`

  let text_show = 'Bekijk referentie'

  if (props.language == 'en') {
    text_show = 'View reference'
    project_url = `/en/reference/${project_slug}`
  }

  return (
      <div className="c-reference c-references__col">
      <div className="c-reference__icon-container">
      <svg className="c-icon c-reference__icon">
      <use href="#fat-quote" xlinkHref="#fat-quote" />
      </svg>
      </div>

      <div
  className="c-reference__content"
  dangerouslySetInnerHTML={{ __html: content }}
  />

  <div className="c-reference__credits">
      <span className="c-reference__person">{person}</span>
      <span className="c-reference__company">{company}</span>
      </div>

      <div className="c-reference__divider" />

      <a href={project_url} className="c-reference__link">
      {text_show}
      <svg className="c-icon c-icon--medium c-reference__link-icon">
      <use href="#chevron-right" xlinkHref="#chevron-right" />
      </svg>
      </a>
      </div>
)
}

export default Reference



// WEBPACK FOOTER //
// ./src/js/references/components/Reference.js